export default __webpack_public_path__ + "static/media/barchart.722fae04.svg";